
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/100w-flexible-solar-panel",
      function () {
        return require("private-next-pages/100w-flexible-solar-panel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/100w-flexible-solar-panel"])
      });
    }
  